import mirrorCreator from 'mirror-creator';

export default mirrorCreator([
  'GO_TO_NEXT_STEP',
  'GO_TO_PREVIOUS_STEP',
  'STEP_CHANGE_REJECTED',
  'GO_TO_STEP',
]);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/constants/checkoutWizardConstants.js